import Format from 'app/src/data/Format';
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

// this must match the data that comes from the API
const _EntryMethods = {
  SWIPE: 'Swipe',
  MANUAL: 'Manual',
};

export default class CCCharge extends RetailModel {
  static get EntryMethod() {
    return _EntryMethods;
  }

  // Server uses the ccChargeID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'ccChargeID';
  }

  get defaults() {
    return {
      gatewayTransID: '',
      xnum: '',
      voided: false,
      refunded: 0.0,
      amount: 0.0,
      exp: '',
      authOnly: false,
      authCode: '',
      ccTransaction: '',
      rawRequest: '',
      cardBrand: '',
      cardType: '',
      entryMethod: '',
      cardholderName: '',
      isDebit: false,
      communicationKey: '',
      timeStamp: '',
      declined: false,
      swipe: '',
      saleID: 0,
    };
  }

  get retailResponseName() {
    return 'CCCharge';
  }

  /**
   * Return the url for the CCCharge endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/CCCharge');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let ccCharge = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    ccCharge.ccChargeID = Format.parseInt(ccCharge.ccChargeID);
    ccCharge.voided = Format.parseBoolean(ccCharge.voided);
    ccCharge.refunded = Format.parseFloat(ccCharge.refunded);
    ccCharge.amount = Format.parseFloat(ccCharge.amount);
    ccCharge.authOnly = Format.parseBoolean(ccCharge.authOnly);
    ccCharge.isDebit = Format.parseBoolean(ccCharge.isDebit);
    ccCharge.declined = Format.parseBoolean(ccCharge.declined);
    ccCharge.saleID = Format.parseInt(ccCharge.saleID);

    return ccCharge;
  }

  /**
   * Determines if the charge is for a swipe transaction (i.e. card reader)
   *
   * @returns {*|boolean} True if the charge is for a swipe transaction
   */
  isSwipe() {
    let swipeData = this.get('swipe');
    let entryMethod = this.get('entryMethod');

    return (swipeData && swipeData.length) || entryMethod === _EntryMethods.SWIPE;
  }
}
